<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Registrar Métrica
        p.text-secondary.text-sm Registra un nuevo evento de una métrica
        fieldset(:disabled="disabled")
          b-form-group(label="Métrica:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'metric_id'")
            b-form-select(size="sm", :value="template_attribute.value || null", @change="selectMetric(template_attribute, $event)")
              option(:value="null", disabled) --Selecciona métrica--
              option(v-for="metric in metrics", :key="metric.metric_id", :value="metric.metric_id") {{metric.name}}
          div(v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'data'")
            empty-message(v-if="!metric_id", message="Selecciona una métrica")
            empty-message(v-else-if="!metric_attributes.length", message="La métrica no tiene atributos")
            b-form-group.mb-2(label="Datos a guardar:", label-size="sm", v-else)
              b-form-group.mb-1(v-for="metric_attr in metric_attributes", :key="metric_attr.metric_attribute_id", :label="metric_attr.name", label-size="sm", label-cols="4", label-class="bb-1" )
                vue-tribute(:options="tributeOpts")
                  b-form-input.disabled-white( size="sm", placeholder="Dato", :value="metric_attr.value", @input="updateData(metric_attr, $event, template_attribute)")
</template>

<script>
import templateCommon from '../../helpers/template-common'
import Connector from './connectors/Connector.vue'
import TemplateTools from './common/Tools.vue'
import ResultDescription from "./helpers/ResultDescription"
import _debounce from 'lodash.debounce'
import { createNamespacedHelpers, mapActions } from 'vuex'
const accountController = createNamespacedHelpers('account')
const metricController = createNamespacedHelpers('metric')

export default {
  mixins: [templateCommon],
  data () {
    return {
      metric_id: null,
      metric_attributes: []
    }
  },
  computed: {
    ...accountController.mapState({
      user_attributes: state => state.attrs
    }),
    ...metricController.mapState({
      metrics: state => state.metrics
    }),
    metric_data () {
      let metric_attr = this.getAttribute('data')
      if (metric_attr && metric_attr.value) {
        try {
          return JSON.parse(metric_attr.value)
        }catch (e) {
          return []
        }
      }
      return []
    }
  },
  methods: {
    ...mapActions(['account/attributes', 'metric/all', 'metric/attributes']),
    getMetrics () {
      let self = this
      this['metric/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getUserAttributes () {
      let self = this

      this['account/attributes']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getMetricAttrs () {
      let self = this

      this['metric/attributes']({
        metric_id: self.metric_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.metric_attributes = res.resource.map(metric_attribute => {
              let data = this.metric_data.find(el => el.metric_attribute_id === metric_attribute.metric_attribute_id)
              if(data) {
                metric_attribute.value = data.value
              } else if (metric_attribute.user_attribute_id) {
                let attr = this.user_attributes.find(el =>  el.user_attribute_id === metric_attribute.user_attribute_id)
                metric_attribute.value = attr ? `{{${attr.name}}}` : ''
              }
              return metric_attribute
            })
            self.updateTemplateAttributeData()
          }
        }
      })
    },
    updateTemplateAttributeData () {
      let attribute_data = this.getAttribute('data')
      if(attribute_data) {
        let data = this.metric_attributes.map(el => {
          return {
            metric_attribute_id: el.metric_attribute_id,
            value: el.value || ''
          }
        })
        attribute_data.value = JSON.stringify(data)
        this.updateAttribute(this.block_id, this.template_id, attribute_data)
      }
    },
    updateData ({metric_attribute_id}, event, template) {
      let element = this.metric_data.find(el => el.metric_attribute_id === metric_attribute_id)
      if(element) {
        element.value = event
        this.updateTemplateAttribute(template, JSON.stringify(this.metric_data))
      }
    },
    selectMetric (template, value) {
      template.value = value
      this.updateAttribute(this.block_id, this.template_id, template)
      this.metric_id = value
      //this.updateData()
    }
  },
  components: {
    'template-connector': Connector,
    TemplateTools,
    ResultDescription,
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId) => {
      if (collapseId === `advance_search_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
    this.getUserAttributes()
    this.getMetrics()
    let metric_attr = this.getAttribute('metric_id')
    if (metric_attr && metric_attr.value) {
      this.metric_id = metric_attr.value
    }
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, attribute)
    }, 1500, { leading: false, trailing: true })
  },
  watch: {
    metric_id (val) {
      if(val) this.getMetricAttrs()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
